<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      label-width="68px"
    >
      <el-form-item label="关键字" prop="key">
        <el-input
          v-model="queryParams.condition.key"
          placeholder="请输入关键字"
          clearable
          style="width: 240px"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      v-loading="loading"
      :data="userList"
      height="calc(100vh - 300px)"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :row-style="{ height: '58px' }"
      border
    >
      <el-table-column
        label="任务编号"
        align="center"
        prop="taskNo"
        width="150"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="项目名称"
        align="center"
        prop="projectName"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="工单名称"
        align="center"
        prop="orderName"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="任务名称"
        align="center"
        prop="taskName"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="工单需求描述"
        align="center"
        prop="taskDescription"
        :show-overflow-tooltip="true"
      >
      </el-table-column>

      <!-- <el-table-column
        label="工时/天"
        align="center"
        prop="taskWorkHours"
        width="100"
        :show-overflow-tooltip="true"
      /> -->
      <el-table-column
        label="工单状态"
        align="center"
        prop="taskStatus"
        width="120"
      >
        <template slot-scope="scope">
          <el-tag>{{ scope.row.taskStatus | StatusFiltering }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="任务归属人"
        align="center"
        prop="personNames"
        width="160"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="开始时间"
        align="center"
        prop="taskStartDate"
        width="130"
        :show-overflow-tooltip="true"
      
      :formatter="dateTimeTwoLine"
      class-name="cell-two-line"
      >
      </el-table-column>
      <el-table-column
        label="结束时间"
        align="center"
        prop="taskEndDate"
        width="130"
        :show-overflow-tooltip="true"
      
      :formatter="dateTimeTwoLine"
      class-name="cell-two-line"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="260"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <!-- <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            v-if="scope.row.isFinish != 2"
            @click="handleAccept(scope.row, 'QRcode')"
            >生成签字二维码</el-button
          > -->
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            v-if="
              scope.row.isFinish != 1 && filtersFunction(scope.row.personIds)
            "
            @click="finishTask(scope.row, 'finish')"
            >任务提交</el-button
          >
          <el-button size="mini" type="success" @click="viewDetails(scope.row)"
            >任务详情</el-button
          >
          <el-button
            size="mini"
            type="info"
            icon="el-icon-download"
            v-if="scope.row.orderFileUrl != ''"
            style="margin-left: 10px"
            @click="handleDownload(scope.row)"
            >工单附件</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.page"
      :limit.sync="queryParams.limit"
      :pageSizes="[50, 100, 200, 500]"
      @pagination="getList"
    />
    <!-- <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      width="50%"
      class="QRcode"
      :close-on-click-modal="false"
    >
      <QRcode ref="child" id="screenshot"></QRcode>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveToGallery">下 载</el-button>
      </span>
    </el-dialog> -->
    <el-dialog
      :visible.sync="dialogVisibleB"
      :show-close="false"
      width="40%"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        v-if="dialogVisibleB"
      >
        <el-form-item label="服务内容" prop="serveContent">
          <quillEditor
            :editorContent="ruleForm.serveContent"
            @change="changeEditor"
          ></quillEditor>
        </el-form-item>
        <el-form-item label="服务概述" prop="serveAbbr">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 2 }"
            v-model="ruleForm.serveAbbr"
          ></el-input>
        </el-form-item>
        <el-form-item label="结果选项" prop="resultOption">
          <el-radio-group v-model="ruleForm.resultOption">
            <el-radio label="1">已完成</el-radio>
            <el-radio label="2">未完成</el-radio>
            <el-radio label="3">处理中</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="处理结果" prop="handleResult">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            v-model="ruleForm.handleResult"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="是否需要签字"
          prop="signFlag"
          label-width="140px"
          v-if="ruleForm.resultOption == '1'"
        >
          <el-switch
            v-model="ruleForm.signFlag"
            active-text="是"
            inactive-text="否"
          >
          </el-switch>
        </el-form-item> -->
        <el-form-item label="上传附件" prop="description" label-width="100px">
          <el-upload
            class="upload-demo"
            :action="this.$store.state.IPAss.TP + '/work/file/upload/2'"
            :headers="customHeaders"
            :before-remove="beforeRemove"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            multiple
            :file-list="FileUrl"
            name="multipartFile"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleB = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitTaskForm"
          :loading="submitLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="title + '详情'"
      :visible.sync="dialogVisibleDeta"
      width="45%"
      :close-on-click-modal="false"
    >
      <my-timeline :events="timelineEvents" />
    </el-dialog>
  </div>
</template>
  
  <script>
import {
  orderTaskPage,
  submitTask,
  getistByTaskId,
} from "@/api/work/WorkTaskList";
import * as htmlToImage from "html-to-image";
import MyTimeline from "@/components/Timeline";
import quillEditor from "@/components/quillEditor";
import { downloadFileByPost } from "@/utils/filenRequest.js";

export default {
  components: {
    MyTimeline,
    quillEditor,
  },
  data() {
    return {
      // 自定义请求头
      customHeaders: {
        userIdStr: window.sessionStorage.getItem("userIdStr"),
      },
      editorContent: "",
      title: "",
      userList: [],
      // 总条数
      total: 0,
      submitLoading: false,
      FileUrl: [], //存文件的数组
      fileList: null,
      // 遮罩层
      loading: false,
      loadingDi: false,
      dialogVisible: false,
      dialogVisibleB: false,
      dialogVisibleDeta: false,
      timelineEvents: [],
      FileUrl: [], //存文件的数组
      ruleForm: {
        taskId: "",
        handleResult: "",
        resultOption: "1",
        serveContent: "",
        serveAbbr: "",
        signFlag: true,
        taskFileUrl: "",
      },
      queryParams: {
        limit: 50,
        page: 1,
        condition: {
          orderStatus: "wait_do",
          key: "",
        },
        orderBy: "",
      },
      rules: {
        resultOption: [
          { required: true, message: "请输入处理结果", trigger: "change" },
        ],
        serveAbbr: [
          { required: true, message: "请输入服务概述", trigger: "blur" },
        ],
        handleResult: [
          { required: true, message: "请输入处理结果", trigger: "blur" },
        ],
        serveContent: [
          { required: true, message: "请输入服务内容", trigger: "blur" },
        ],
        signFlag: [
          {
            required: true,
            message: "请输入服务内容",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    changeEditor(info) {
      this.ruleForm.serveContent = info;
    },
    /** 查询用户列表 */
    async getList() {
      this.loading = true;
      let { data } = await orderTaskPage(this.queryParams);
      this.userList = data.records;
      this.total = data.total;
      this.loading = false;
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams.condition.key = undefined;
      this.getList();
    },
    handleAccept(e) {
      this.dialogVisible = true;
      this.$nextTick(function () {
        this.$refs.child.createQRCode(e);
      });
    },
    //完成任务
    async finishTask(e) {
      this.ruleForm.taskId = e.taskId;
      this.dialogVisibleB = true;
    },
    //任务详情
    async viewDetails(row) {
      this.title = row.orderName;
      let { data } = await getistByTaskId(row.taskId);
      this.timelineEvents = data;
      this.dialogVisibleDeta = true;
    },
    //提交任务
    submitTaskForm() {
      this.$refs["ruleForm"].validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          try {
            let res = await submitTask(this.ruleForm);
            if (res.code == 200) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.ruleForm = {};
            }
            this.getList();
            this.dialogVisibleB = false;
            this.submitLoading = false;
          } catch (error) {
            return Promise.reject(error);
          }
        }
      });
    },
    async saveToGallery() {
      htmlToImage
        .toJpeg(document.getElementById("screenshot"), { quality: 0.95 })
        .then(function (dataUrl) {
          var link = document.createElement("a");
          link.download = "my-image-name.jpeg";
          link.href = dataUrl;
          link.click();
        });
    },
    //附件下载
    async handleDownload(url) {
      downloadFileByPost(url.orderFileUrl);
    },
    //过滤
    filtersFunction(value) {
      const UID = JSON.parse(window.sessionStorage.getItem("uid"));
      const n = value.includes(UID);
      console.log(n);
      return n;
    },
    handleSuccess(file, fileList) {
      this.fileList = file;
      this.ruleForm.taskFileUrl = file.data.fileUrl;
      console.log(this.ruleForm.taskFileUrl);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file, fileList) {
      this.ruleForm.taskFileUrl = "";
      this.fileList = [];
    },
  },
};
</script>
  
<style lang="scss" scoped>
.app-container {
  .QRcode {
    ::v-deep .el-dialog {
      height: 760px;
      width: 390px !important;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      background: none;
      box-shadow: none;
    }
    ::v-deep .el-dialog__wrapper {
      top: 80px;
    }
    ::v-deep.el-dialog__header {
      display: none;
    }
    ::v-deep .el-dialog__body {
      padding: 0;
    }
    ::v-deep.el-dialog:not(.is-fullscreen) {
      margin-top: 4vh !important;
    }
  }
  .tite-box {
    line-height: 30px;
    .font {
      // font-weight: 600;
      font-size: 16px;
    }
  }
  ::v-deep .el-collapse {
    border: none;
  }
}
</style>